import { useState } from "react";
import "./styles.css";

const Tooltip = ({ text, children, position, type }) => {
  const [visible, setVisible] = useState(false);
  let tooltipClass = "tooltip";
  let tooltipTextClass = "tooltip-text";

  if (type === "coco-config") {
    tooltipClass =
      position === "left" ? "tooltip-left tooltip-left-coco-config" : "tooltip";
    tooltipTextClass = "tooltip-text-coco-config";
  } else if (type === "configuration-capture-date-timezone") {
    tooltipClass = "tooltip-configuration-capture-date-timezone";
  } else if (type == "profile-card") {
    tooltipClass = `${tooltipClass} tooltip-profile-card`;
  } else if (type == "subIdentityAlaises-history") {
    tooltipClass = `${tooltipClass} tooltip-subid-alias-history`;
  } else if (type == "content-library") {
    tooltipClass =
      position === "left"
        ? `tooltip-left tooltip-left-content-library`
        : `tooltip-right tooltip-right-content-library`;
  } else {
    tooltipClass = position === "right" ? "tooltip-right" : "tooltip-left";
    if (position === "center") {
      tooltipClass = `${tooltipClass} tooltip-center`;
    }
    if (position === "pos-25") {
      tooltipClass = `${tooltipClass} tooltip-pos-25`;
    }
  }

  return (
    <div
      role="tooltip"
      className="tooltip-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className={tooltipClass}>
          <span className={tooltipTextClass}>{text}</span>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
